export default defineNuxtPlugin((nuxtApp) => {
  // add redirects from locale pages to root until i18n is added
  nuxtApp.$router.beforeEach(async (to, from) => {
    if (to.fullPath.match(/^\/\w{2}\/.*/)) {
      const toPath = to.fullPath.replace(/^\/\w{2}/, "");
      return toPath;
    }
  });
});
